import { object, string } from "yup";

export const insertCustomerWithExcel = object({
    username: string().nullable()
        .required("Kullanıcı Adı Seçmeniz zorunlu."),
    password: string().nullable()
        .required("Parola Seçimi Zorunlu."),
})